import { createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'
import rootReducer from './reducers'

const loggerMiddleware = createLogger({
  collapsed: true,
  //  level: 'warn',
})

export default function configureStore(preloadedState) {
  let middleWare = applyMiddleware(thunkMiddleware);
  if (localStorage.getItem('devlog') === '1') {
    middleWare = applyMiddleware(thunkMiddleware, loggerMiddleware);
  }
  return createStore(
    rootReducer,
    preloadedState,
    middleWare
  )
}